"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerDayBox = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _datePickerTheme = require("./datePickerTheme");
// A single box in the calendar grid.
// contains shared styles between the week headers and the days.
const DatePickerDayBox = (0, _styled.default)("div")`
    box-sizing: border-box;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    background-color: transparent;
    transition: background-color ${_ref => {
  let {
    themeMode
  } = _ref;
  return _datePickerTheme.datePickerTheme.dayTransitionDuration[themeMode];
}} ease-out;

    // For Ursa, we need to add a bit of extra spacing between the days (but not outside the
    // left/right edges). We can't use css grid column-gap because the DateRangePickerDialog needs
    // contiguous boxes to apply the highlight between the start/end dates.
    &:not(:nth-of-type(7n + 1)) {
        padding-left: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _datePickerTheme.datePickerTheme.dayInnerPadding[themeMode];
}};
    }
    &:not(:nth-of-type(7n)) {
        padding-right: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return _datePickerTheme.datePickerTheme.dayInnerPadding[themeMode];
}};
    }
`;
exports.DatePickerDayBox = DatePickerDayBox;
//# sourceMappingURL=DatePickerDayBox.js.map